import { html, render } from "lit-html";
import { choose } from "lit-html/directives/choose.js";
import { translate } from "@escapio/shared/l10n/translate";
import { getFormatter } from "@escapio/shared/l10n/currency";
import { travelData } from "@escapio/portal/state/travelData";
import {
	STATE_LOADING,
	STATE_DIRECT_LINK_ONLY,
	STATE_AVAILABLE,
	STATE_WITHOUT_DATES,
	STATE_UNAVAILABLE,
} from "@escapio/portal/state/HotelPriceLoadingStates";
import { linkTargetForProfile } from "../../hotel-list/get-offer-url";
import { addEventTrackerData } from "@escapio/portal/tracker/EventQueue";
import "@escapio/shared/components/Picture";
import "@escapio/portal/components/hotel-list/hotel-element/MobileStage";
import "@escapio/portal/components/hotel-list/hotel-element/MobileDescription";

class PopupContent extends HTMLElement {
	constructor() {
		super();
		this.hotel = null;
		this.prices = null;
	}

	async connectedCallback() {
		this.render();
	}

	render() {
		render(this.template, this, { host: this });
	}

	get template() {
		const format = getFormatter(travelData.currency);

		const goToProfileTemplate = html`<a
			href="${this.hotel.path}"
			@click=${this.onProfileLinkOnCTAClick}
			target=${linkTargetForProfile}
		>
			<span class="map-hotel-popup__cta--edl"
				>${translate("hotel_go_to_profile")}</span
			>
		</a>`;

		return html`<esc-hotel-list-hotel-stage-mobile
				.hotel="${this.hotel}"
				picture-gallery-track-name-suffix=" (Karte)"
				favorites-track-action-suffix=" (Karte)"
				.profileLinkHandler="${this.trackProfileLinkClickV1("Bild")}"
			></esc-hotel-list-hotel-stage-mobile>
			<a href=${this.hotel.path} target=${linkTargetForProfile}
				><esc-hotel-list-hotel-description-mobile
					.hotel=${this.hotel}
					@click="${this.trackProfileLinkClickV1("Hotelname")}"
				></esc-hotel-list-hotel-description-mobile>
			</a>
			<div class="map-hotel-popup__cta-container">
				${choose(
					this.prices?.pricesState,
					[
						[
							STATE_LOADING,
							() =>
								html`<div
									class="map-hotel-popup__cta-placeholder content-placeholder"
								></div>`,
						],
						[
							STATE_AVAILABLE,
							() =>
								html`<a
									href="${this.hotel.path}"
									@click=${this.trackProfileLinkClickV1("Preis")}
									target=${linkTargetForProfile}
								>
									<small class="map-hotel-popup__before-price">
										${translate("basic_from")}
									</small>
									<span class="map-hotel-popup__cta">
										${format(this.prices.offers?.[0]?.total_rate)}
									</span>
								</a>`,
						],
						[STATE_DIRECT_LINK_ONLY, () => goToProfileTemplate],
						[STATE_WITHOUT_DATES, () => goToProfileTemplate],
						[
							STATE_UNAVAILABLE,
							() =>
								html`<div class="map-hotel-popup__cta--price-error">
									${translate("hotel_list_offers_error_loading_price")}
								</div>`,
						],
					],
					() => goToProfileTemplate,
				)}
			</div>`;
	}

	onProfileLinkOnCTAClick() {
		this.dispatchEvent(
			new CustomEvent("PopupProfileLink", {
				detail: { element: "Alle Details" },
			}),
		);
	}

	trackProfileLinkClickV1(origin) {
		return () =>
			addEventTrackerData(
				"Karte",
				`Klick Profil (${this.trackNameV1})`,
				`${origin} - ${this.hotel.id} | ${this.hotel.name}`,
			);
	}
}

customElements.define("esc-maplibre-popup", PopupContent);
